<template>
  <div>
    <navHeader />
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-12 col-lg-12">
          <div>
            <div class="embdd">
              <iframe
                :src="content.embeddedURL"
                frameborder="0"
                marginheight="0"
                marginwidth="0"
                max-width="100%"
                sandbox="allow-forms allow-modals allow-orientation-lock allow-popups allow-same-origin allow-scripts"
                scrolling="yes"
                allowfullscreen
                mozallowfullscreen
                msallowfullscreen
                webkitallowfullscreen
              ></iframe>
            </div>
            <a
              class="archive-bottom d-none"
              href="javascript:void(0)"
              @click="$router.push('/Reports/Archive/LearningGuide')"
            >
              View Learning Guide Archive
            </a> 
            <Disclaimer class="d-none"/>
          </div>
        </div>
      </div>
    </div>
    <Footer style="position:fixed;bottom:0;" class="d-none" />
  </div>
</template>

<script>
import navHeader from "../../ResearchPages/NavHeader";
import Disclaimer from "../ReportsPages/Disclaimer";
import Footer from "../Footer";
import { mapState } from "vuex";
import moment from 'moment';

export default {
  components: {
    Disclaimer,
    navHeader,
    Footer,
  },
  computed: {
    ...mapState({
      content: (state) => state.philstocksResearch.learningGuideReport,
    }),
  },
  methods: {
    GoogleAnalytics() {
      this.$gtag.event("Learning Guide", { method: "Google" });
    },
    FormatDate(date) {
      var result = "";
      if (date == "0001-01-01T00:00:00") {
        result = "--";
      } else {
        result = moment(date).format("MMMM DD, YYYY");
      }
      return result;
    },
    async GetLearningGuideReport(data) {
      var isResponseError = false;
      this.isDataLoaded = true;
      var _this = this;
      await this.$store
        .dispatch("philstocksResearch/GetLearningGuideReport", data)
        .catch(function (error) {
          console.log(error);
          _this.isDataLoaded = false;

          isResponseError = false;
        });

      if (!isResponseError) {
        _this.isDataLoaded = false;
      }
    },
  },
  async mounted() {
    this.GetLearningGuideReport(this.$route.query.date);
  },
};
</script>

<style>
</style>